import React, { Fragment } from 'react';
import axios from '../utils/axios';
import { getUserInfo } from '../utils/authStorage';

export default function Auth({ children }) {
  axios.interceptors.request.use(
    function (config) {
      const token = getUserInfo()?.token;
      if (token) {
        config.headers['Authorization'] = 'Bearer ' + token;
      }
      return config;
    },
    null,
    { synchronous: true }
  );

  return <Fragment>{children}</Fragment>;
}
